// extracted by mini-css-extract-plugin
export default {"semi":"button_semi__Xh5e0","z-index-1":"button_z-index-1__y+480","cursor-pointer":"button_cursor-pointer__3VgKG","button":"button_button__UQ77E"};